export enum ProcessTab {
  CANDIDATE_LIST = 'CANDIDATE_LIST',
  PROCESS_INFORMATION = 'PROCESS_INFORMATION',
}
